import { queryOptions } from "@tanstack/react-query";

import API, { unwrapApiResult } from "~/api";
import { CacheUpdateFrequency } from "~/store/query-client";

export const currentUserKeys = {
  all: ["user"] as const,
  detail: (uuid: string | null) => ["user", uuid] as const,
};

export const getCurrentUserQueryOptions = (uuid: string | null) =>
  queryOptions({
    queryKey: currentUserKeys.detail(uuid),
    queryFn: async () => {
      if (!uuid) {
        throw new Error("User UUID is required to fetch user details.");
      }
      const result = await unwrapApiResult(API.user.getUser(uuid));
      return result.data;
    },
    gcTime: CacheUpdateFrequency.Never,
    staleTime: CacheUpdateFrequency.Never,
    enabled: Boolean(uuid),
  });
